/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useContext, createContext, PropsWithChildren, useEffect } from "react";
import type { Product as IProduct } from "~api/stream/interfaces";

interface IRealtimeProductsContext {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  selectedProducts: IProduct[];
  setSelectedProducts: (value: IProduct[]) => void;
  productList: IProduct[];
  setProductList: (value: IProduct[]) => void;
}

const RealtimeProductsContext = createContext<IRealtimeProductsContext>({
  searchTerm: "",
  setSearchTerm: () => "",
  selectedProducts: [],
  setSelectedProducts: () => [],
  productList: [],
  setProductList: () => [],
});

export const RealtimeProductsContextProvider = ({ children }: PropsWithChildren) => {
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [selectedProducts, setSelectedProducts] = useState<IProduct[]>([]);
  const [productList, setProductList] = useState<IProduct[]>([]);

  useEffect(() => {
    const selectedKeys = selectedProducts.map(
      (p) => p.provider?.productId || String(p.id)
    );
    const updatedProductList = productList.map((product) => ({
      ...product,
      isChecked: selectedKeys.includes(product.provider?.productId || String(product.id)),
    }));
    setProductList(updatedProductList);
  }, [selectedProducts]);

  return (
    <RealtimeProductsContext.Provider
      value={{
        searchTerm,
        setSearchTerm,
        selectedProducts,
        setSelectedProducts,
        productList,
        setProductList,
      }}
    >
      {children}
    </RealtimeProductsContext.Provider>
  );
};

export const useRealtimeProductsContext = () => {
  const context = useContext(RealtimeProductsContext);
  return context;
};
